import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";
import { useL } from "@/context/I18nContext";
import api from "@/lib/api";

export default function PasswordDimenticata() {
  const L = useL();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      setSent(true); // never reveal existence
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={L("Password dimenticata", "Forgot password", "Passwort vergessen")}
      subtitle={L("Inserisci la tua email per ricevere le istruzioni di reimpostazione.", "Enter your email to receive reset instructions.", "Geben Sie Ihre E-Mail-Adresse ein, um Anweisungen zum Zurücksetzen zu erhalten.")}
      footer={<><Link to="/login" className="text-cyanx hover:text-white">← {L("Torna al login", "Back to login", "Zurück zur Anmeldung")}</Link></>}
    >
      {sent ? (
        <div className="rounded-xl border border-cyanx/20 bg-cyanx/5 p-6 text-center" data-testid="forgot-sent">
          <MailCheck className="mx-auto h-8 w-8 text-cyanx" />
          <p className="mt-3 text-sm text-slate-300">{L("Se l'indirizzo esiste, riceverai istruzioni per reimpostare la password.", "If the address exists, you will receive instructions to reset your password.", "Falls die Adresse existiert, erhalten Sie Anweisungen zum Zurücksetzen Ihres Passworts.")}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div><Label className="text-slate-300">{L("Email", "Email", "E-Mail")}</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5 bg-navy-paper border-white/10 h-11" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-gold text-navy hover:bg-gold-hover h-11 font-medium" data-testid="forgot-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : L("Invia istruzioni", "Send instructions", "Anweisungen senden")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
